// crewbit-admin/src/components/schedule/NowIndicator.tsx
//
// Schedule Module Phase C C1.5 — current-time indicator for the Day grid.
// Authored fresh (no admin equivalent existed). Body parallel to mobile
// crewbit-mobile/components/schedule/NowIndicator.tsx mode='positioned' branch
// modulo runtime per feedback_admin_pair_must_match_mobile_body.md.
//
// Spec: docs/references/schedule/SCHEDULE_MODULE_SPEC_v1.md §2.2.

import { useEffect, useState } from 'react';
import { palette } from '../../styles/tokens';
import { instantToBusinessParts } from './scheduleHelpers';

export interface NowIndicatorProps {
  /** Container height in px — line positions proportionally within. */
  containerHeight: number;
  /** Day window start hour (0-23). */
  dayStartHour: number;
  /** Day window end hour (1-24, exclusive). */
  dayEndHour: number;
}

export default function NowIndicator({ containerHeight, dayStartHour, dayEndHour }: NowIndicatorProps) {
  const [, setTick] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => setTick((t) => t + 1), 60000);
    return () => clearInterval(timer);
  }, []);

  // A2 P4 — express "now" in the business tz so the line lands correctly on the
  // business-hours grid when the device tz differs from the business tz.
  const nowBiz = instantToBusinessParts(new Date().toISOString());
  const ampm = nowBiz.hour >= 12 ? 'PM' : 'AM';
  const h12 = nowBiz.hour % 12 || 12;
  const label = `${h12}:${String(nowBiz.minute).padStart(2, '0')} ${ampm}`;
  const minutesSinceStart = (nowBiz.hour - dayStartHour) * 60 + nowBiz.minute;
  const totalMinutes = (dayEndHour - dayStartHour) * 60;
  if (minutesSinceStart < 0 || minutesSinceStart > totalMinutes) return null;

  const top = (minutesSinceStart / totalMinutes) * containerHeight;

  return (
    <div
      aria-hidden
      style={{
        position: 'absolute',
        left: 0, right: 0,
        top,
        display: 'flex', alignItems: 'center',
        zIndex: 5,
        pointerEvents: 'none',
      }}
    >
      <span style={{ fontSize: 10, fontWeight: 700, color: palette.red, marginLeft: 8, marginRight: 4 }}>
        {label}
      </span>
      <span style={{ flex: 1, height: 2, backgroundColor: palette.red }} />
    </div>
  );
}
